"use strict";

exports.__esModule = true;
exports.UtilizationChartFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _aggregates = require("../../VIMANAMetrics/Sections/aggregates");
var _utils = require("../common/MetricsFilters/utils");
var _tooltipSort = require("../common/tooltipSort");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Well = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartFields__Well",
  componentId: "sc-rm2sqt-0"
})(["padding:7px;border:2px dashed #ddd;margin-bottom:10px;"]);
var WellTitle = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartFields__WellTitle",
  componentId: "sc-rm2sqt-1"
})(["font-weight:bold;margin-bottom:10px;"]);
var AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationChartFields__AxisControls",
  componentId: "sc-rm2sqt-2"
})(["display:flex;> label{margin-right:15px;}"]);
var LegendsWell = (0, _styledComponents["default"])(Well).withConfig({
  displayName: "UtilizationChartFields__LegendsWell",
  componentId: "sc-rm2sqt-3"
})(["opacity:", ";label.disabled,input:disabled{cursor:not-allowed;}"], function (props) {
  return props.disabled ? 0.3 : 1;
});
var UtilizationChartFields = exports.UtilizationChartFields = function UtilizationChartFields(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var selectedAggregates = element.props.aggregations.filter(function (child) {
    return child.section === "aggregates";
  });
  var aggregationItems = (0, _utils.flattenAggregates)([_aggregates.byTime]);
  var CheckboxEl = function CheckboxEl(_ref) {
    var propName = _ref.propName,
      defaultLabel = _ref.defaultLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
    return /*#__PURE__*/_react["default"].createElement("label", {
      className: disabled ? "disabled" : "",
      htmlFor: propName
    }, /*#__PURE__*/_react["default"].createElement("input", {
      disabled: disabled,
      id: propName,
      type: "checkbox",
      checked: element.props[propName] || false,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, propName, e.target.checked);
      }
    }), " ", translate("MetricChartFields.axes." + propName + ".label", defaultLabel));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("UtilizationChartFields.tooltipSort.label", "Sort")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "UtilizationChartFields.tooltipSort",
    value: element.props.tooltipSort || _tooltipSort.TOOLTIP_SORT_DESC,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "tooltipSort", e.target.value);
    }
  }, _tooltipSort.TOOLTIP_SORT_OPTIONS.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.key,
      value: option.key
    }, translate("UtilizationChartFields.tooltipSort." + option.key, option.label));
  })))), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "X Axis")), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    placeholder: translate("MetricChartFields.select-aggregate", "Select Aggregate"),
    getKey: function getKey(item) {
      return item.name;
    },
    renderItemText: function renderItemText(item) {
      return item.label;
    },
    items: aggregationItems,
    selected: selectedAggregates,
    style: {
      marginBottom: 10
    },
    onSelect: function onSelect(selected) {
      if (!(0, _reactFastCompare["default"])(selectedAggregates, selected)) {
        var groups = selected.reduce(function (acc, item) {
          acc[item.groupId] = item;
          return acc;
        }, {});
        var values = Object.values(groups);
        elementEditor.setProps(path, {
          aggregations: values
        });
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideXAxis",
    defaultLabel: "Hide Axis"
  }), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideXUnits",
    defaultLabel: "Hide Label"
  }))), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "Y Axis")), /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideYAxis",
    defaultLabel: "Hide Axis"
  }), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideYUnits",
    defaultLabel: "Hide Label"
  }))), /*#__PURE__*/_react["default"].createElement(LegendsWell, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.showLegends", "Legend")), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "showLegends",
    defaultLabel: "Show Legend"
  })));
};